import { useMemo } from 'react';
import { AmlTraceHistoryItemData } from '@/redux/models';
import { TraceTypeEnum } from '@/config';
import { TraceHistoryMessage } from '../components/TraceHistoryMessages/TraceHistoryMessages';

interface UseTraceStatusResult {
  visualizationUrl: string | null;
  statusMessages: TraceHistoryMessage[];
  errorMessages: TraceHistoryMessage[];
  hasVisualization: boolean;
}

function useTraceStatus(
  item: AmlTraceHistoryItemData | null | undefined,
  traceUpdates: any[],
): UseTraceStatusResult {
  const visualizationUrl = useMemo(() => {
    if (item?.info?.visualizationUrl) {
      return item.info.visualizationUrl;
    }

    if (traceUpdates?.length) {
      const visualization = traceUpdates.find(
        (update) => update?.visualizationUrl,
      );
      return visualization?.visualizationUrl || null;
    }

    return null;
  }, [item, traceUpdates]);

  const statusMessages = useMemo((): TraceHistoryMessage[] => {
    if (!traceUpdates?.length) return [];

    return traceUpdates
      .filter(
        (update) => update?.type === TraceTypeEnum.STATUS && update?.message,
      )
      .map((update, idx) => ({ idx, message: update.message }));
  }, [traceUpdates]);

  const errorMessages = useMemo((): TraceHistoryMessage[] => {
    if (!traceUpdates?.length) return [];

    return traceUpdates
      .filter(
        (update) => update?.type === TraceTypeEnum.ERROR && update?.message,
      )
      .map((update, idx) => ({ idx, message: update.message }));
  }, [traceUpdates]);

  return {
    visualizationUrl,
    statusMessages,
    errorMessages,
    hasVisualization: !!visualizationUrl,
  };
}

export default useTraceStatus;
